import React, { useState } from "react";
import { TextField, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import apiUrl from "../api";

import axios from "axios";

const AddPriorityOption = () => {
  const [priorityName, setPriorityName] = useState("");
  const [priorityColor, setPriorityColor] = useState("#FA0808");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const user = JSON.parse(localStorage.getItem("user"));

  const handleAddPriority = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (priorityName === "") {
      return setError("Priority name is required.");
    }

    // Add your API call here to add the priority
    try {
      const response = await axios.post(

        `${apiUrl}/ticket-options/createPriorityOption`,
        {
          title: priorityName,
          color: priorityColor,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSuccess("Priority added successfully.");
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setError("Priority already exists.");
      } else {
        setError("Failed to add priority. Please try again.");
      }
    }

    setPriorityName("");
    setPriorityColor("#FA0808"); // Reset color to default after adding the priority
  };

  return (
    <div className="add-priority-option-wrapper">
      {error && <Alert severity="error">{error}</Alert>}
      {success && <Alert severity="success">{success}</Alert>}
      <h4
        style={{
          marginBottom: "0px",

          fontWeight: "600",
        }}
      >
        Add Priority
      </h4>
      <form
        onSubmit={handleAddPriority}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          alignItems: "center",
        }}
      >
        <TextField
          variant="outlined"
          label="Priority Name"
          placeholder="Priority Name"
          value={priorityName}
          onChange={(e) => setPriorityName(e.target.value)}
          fullWidth
          margin="normal"
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
          }}
        />
        <TextField
          variant="outlined"
          type="color"
          label="Label Color"
          value={priorityColor}
          onChange={(e) => setPriorityColor(e.target.value)}
          margin="normal"
          sx={{
            width: "20%",
          }}
          // Custom styling may be required for color input to look consistent
          InputProps={{
            inputProps: { style: { height: "56px", padding: "5px" } }, // Adjust the style as needed
          }}
        />
        <button
          className="add-ticket-button__button"
          sx={{
            backgroundColor: "var(--primary-color)",
            color: "var(--primary-text-color)",
            fontSize: "15px",
            fontWeight: "600",
            width: "auto",
            padding: "10px 20px",
          }}
          onClick={() => {}}
        >
          <AddIcon />
          <span>Add</span>
        </button>
      </form>
    </div>
  );
};

export default AddPriorityOption;
